module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "map02"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/p02-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "captionf"
  }, [_vm._v("Map 2 shows places associated with D Battalion during the Third Battle of Ypres (July–October 1917). French place-names are shown, as these were generally used by the British Army at the time.")]), _vm._v(" "), _c('p', {
    staticClass: "captionfi"
  }, [_vm._v("To the left is the town of Poperinghe, with La Lovie Château to the north and the camp which was home to D Battalion throughout the campaign. The tankodrome and workshops were in Oosthoek Wood, and the areas allocated to four tank battalions are shown (E Battalion also subsequently moved into the wood).")]), _vm._v(" "), _c('p', {
    staticClass: "captionfi"
  }, [_vm._v("The crew of D51 left here for their first action on 19 August, moving along a supply route called Rum Road to spend the night at Murat Farm before reaching the Yser Canal north of Ypres. A number of crossing-points were used by tanks, including Bridge 4 (‘Brielen Bridge’) beside Essex Farm and ‘Marengo Causeway’ to the north. This brought them into the Ypres Salient, indicated by a thick dotted line showing the German positions in July 1917 (i.e. before the start of the offensive). By August the Germans had been driven back beyond St Julien, and after crossing the canal, the tanks moved along a supply route called Buffs Road to reach the former farm of Bellevue near the original German front-line. Here they prepared for their attack.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff7c2c00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/11_part01a.vue
// module id = 93
// module chunks = 0